import SEOHead from "@/components/base/SEOHead";
import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import WhatsAppFloat from "@/components/feature/WhatsAppFloat";
import Breadcrumb from "@/components/feature/Breadcrumb";
import TrustBannerSection from "@/components/feature/TrustBannerSection";

export default function Privacidad() {
  return (
    <div className="min-h-screen bg-background-50">
      <SEOHead
        title="Política de Privacidad | Persianas Málaga"
        description="Política de privacidad de Persianas Málaga. Tratamiento de datos personales conforme al RGPD. Reparación de persianas y mosquiteras en Málaga capital."
        noindex
      />
      <Navbar />
      <Breadcrumb items={[
        { label: "Inicio", path: "/" },
        { label: "Privacidad" },
      ]} />
      <main className="pb-20 md:pb-0">
        <section className="py-14 md:py-20">
          <div className="px-4 md:px-6 max-w-3xl mx-auto">
            <h1 className="text-3xl md:text-4xl font-bold text-foreground-950 mb-8 font-heading">Política de Privacidad</h1>
            <div className="prose prose-sm max-w-none text-foreground-700 space-y-6">
              <p>De conformidad con el Reglamento General de Protección de Datos (RGPD) y la Ley Orgánica de Protección de Datos y Garantía de los Derechos Digitales (LOPDGDD), le informamos sobre el tratamiento de sus datos personales.</p>
              <h2 className="text-xl font-bold text-foreground-950 font-heading mt-8">Responsable del tratamiento</h2>
              <ul className="list-disc pl-6 space-y-2">
                <li><strong>Responsable:</strong> Persianas Málaga</li>
                <li><strong>Email:</strong> info@persianas-malaga.es</li>
              </ul>
              <h2 className="text-xl font-bold text-foreground-950 font-heading mt-8">Finalidad del tratamiento</h2>
              <p>Los datos personales facilitados a través de los formularios de este sitio web serán tratados con la finalidad de atender su solicitud de presupuesto o consulta, así como para el envío de comunicaciones comerciales si usted lo autoriza expresamente.</p>
              <h2 className="text-xl font-bold text-foreground-950 font-heading mt-8">Legitimación</h2>
              <p>La base legal para el tratamiento de sus datos es el consentimiento que usted nos otorga al enviar el formulario, así como el interés legítimo en responder a sus consultas.</p>
              <h2 className="text-xl font-bold text-foreground-950 font-heading mt-8">Derechos</h2>
              <p>Usted tiene derecho a acceder, rectificar, suprimir, limitar y oponerse al tratamiento de sus datos, así como a la portabilidad de los mismos. Puede ejercer estos derechos enviando un email a info@persianas-malaga.es.</p>
            </div>
          </div>
        </section>
      </main>
      <TrustBannerSection />
      <Footer />
      <WhatsAppFloat />
    </div>
  );
}